import store from 'src/js/store';
import getIntegrationType from '../selectors/get-integration-type';
import wonderchat from '../wonderchat';
import integrationTypes from '../constants/integration-types';
import getSnippetInstance from '../zend-desk/get-snippet-instance';

const showForm = async () => {
  const state = store.getState();
  const integration = getIntegrationType(state);

  switch (integration) {
    case integrationTypes.ZENDESK: {
      const widget = await getSnippetInstance();
      widget.show();
      break;
    }

    case integrationTypes.WONDERCHAT: {
      wonderchat.show();
      break;
    }

    default:
  }
};

export default showForm;
